import { useEffect, useMemo, useState } from "react";

import placeholderImg from "../assets/logos/flipspaces-black.png";

/* --- Robust Drive Helpers --- */
function extractDriveFileId(url = "") {
  const s = String(url || "").trim();
  if (!s) return null;
  const patterns = [
    /\/file\/d\/([a-zA-Z0-9_-]+)/,
    /\/d\/([a-zA-Z0-9_-]+)/,
    /[?&]id=([a-zA-Z0-9_-]+)/,
    /thumbnail\?id=([a-zA-Z0-9_-]+)/,
    /lh3\.googleusercontent\.com\/d\/([a-zA-Z0-9_-]+)/,
    /drive\.usercontent\.google\.com\/uc\?id=([a-zA-Z0-9_-]+)/,
  ];
  for (const p of patterns) {
    const m = s.match(p);
    if (m?.[1]) return m[1];
  }
  return null;
}

function isProbablyDriveId(x) {
  const s = String(x || "").trim();
  return /^[a-zA-Z0-9_-]{20,}$/.test(s);
}

function getDriveImageCandidates(urlOrId = "") {
  if (!urlOrId) return [placeholderImg];
  const raw = String(urlOrId).trim();
  const extracted = extractDriveFileId(raw);
  const id = extracted || (isProbablyDriveId(raw) ? raw : null);
  if (!id) return [raw];
  return [
    `https://lh3.googleusercontent.com/d/${id}=w1400`,
    `https://drive.usercontent.google.com/uc?id=${id}&export=view`,
    `https://drive.google.com/thumbnail?id=${id}&sz=w1400`,
    `https://drive.google.com/uc?export=view&id=${id}`,
  ];
}

export default function ImageWithFallback({ src, alt, className }) {
  const candidates = useMemo(() => getDriveImageCandidates(src), [src]);
  const [idx, setIdx] = useState(0);

  useEffect(() => setIdx(0), [src, candidates.length]);

  // Past the last candidate (every one failed to load) → the Flipspaces mark.
  const finalSrc = candidates[idx] || placeholderImg;

  return (
    <img
      className={className}
      src={finalSrc}
      alt={alt}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => {
        if (idx < candidates.length) setIdx(idx + 1);
      }}
    />
  );
}
